
export const EVENT_TYPE = new Map();

//mouse
EVENT_TYPE.set("mouse:down", "mousedown");
EVENT_TYPE.set("mouse:move", "mousemove");
EVENT_TYPE.set("mouse:up", "mouseup");
EVENT_TYPE.set("mouse:out", "mouseout");
//pointer
EVENT_TYPE.set("pen:down", "pointerdown");
EVENT_TYPE.set("pen:move", "pointermove");
EVENT_TYPE.set("pen:up", "pointerup");
EVENT_TYPE.set("pen:out", "pointerout");
//touch
EVENT_TYPE.set("touch:down", "touchstart");
EVENT_TYPE.set("touch:move", "touchmove");
EVENT_TYPE.set("touch:up", "touchend");
EVENT_TYPE.set("touch:out", "touchcancel");

/**
 * 
 * @param {Event} e 
 * @returns {{x: number, y:number}}
 */
export function getPointer(e) {
    if(e.type.includes("touchend")) {
        return {x: e.changedTouches[0].screenX, y: e.changedTouches[0].screenY};
    }else if(e.type.includes("touch")) {
        return {x: e.touches[0].screenX, y: e.touches[0].screenY};
    }else if(e.type.includes("pointer")) {
        return {x: e.clientX, y: e.clientY};
    }else if(e.type.includes("mouse")) {
        return {x: e.clientX, y: e.clientY};
    }
}